import React, { useMemo } from "react";
import "./TableStyles.css";
import {
  useReactTable,
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
} from "@tanstack/react-table";

const MainTable = ({
  columns,
  data,
  initialPageSize,
  pageNumber,
  onPageIndexChange,
  onPageSizeChange,
  enablePagination = true,
  totalRecords,
  className = "",
  recordCountText = "records found"
}) => {
  // Adjust pageNumber to zero-based indexing for useReactTable
  const pageIndex = useMemo(() => pageNumber - 1, [pageNumber]);
  const totalPages = useMemo(() => Math.ceil(totalRecords / initialPageSize), [totalRecords, initialPageSize]);

  const tableInstance = useReactTable({
    columns,
    data,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: enablePagination ? getPaginationRowModel() : undefined,
    options: {
      state: {
        pagination: {
          pageIndex,
          pageSize: initialPageSize,
        },
      },
    },
    defaultColumn: {
      // size: 200, //starting column size
      minSize: 20, //enforced during column resizing
      maxSize: 500, //enforced during column resizing
    },
  });

  // console.log('Table instance is ', tableInstance)

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    onPageSizeChange(newSize);
    tableInstance.setPageSize(newSize);
    // console.log('Inside table instance page size change is ', newSize)
    // Optionally reset to the first page after changing page size
    onPageIndexChange(1);
  };

  // Navigation helpers adjusted for one-based index system
  const navigatePage = (action) => {
    switch (action) {
      case 'first': onPageIndexChange(1); break;
      case 'prev': onPageIndexChange(Math.max(1, pageNumber - 1)); break;
      case 'next': onPageIndexChange(pageNumber + 1); break;
      case 'last': onPageIndexChange(Math.ceil(totalRecords / initialPageSize)); break;
      default: break;
    }
  };
  const isFirstPage = pageNumber === 1;
  const isLastPage = pageNumber >= totalPages;
  const disabledButtonStyle = { color: 'grey', cursor: 'not-allowed' };

  return (
    <>
      <div className={`card ${className}`}>
        <div className="card-body">
          <div className="table-responsive">
            <table className="cspadi table">
              {/* Table Head */}
              <thead className="table-header">
                {tableInstance.getHeaderGroups().map(headerGroup => (
                  <tr key={headerGroup.id}>
                    {headerGroup.headers.map(column => (
                      <th key={column.id} colSpan={column.colSpan}>
                        {flexRender(column.column.columnDef.header, column.getContext())}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              {/* Table Body */}
              <tbody>
                {tableInstance.getRowModel().rows.map(row => (
                  <tr key={row.id}>
                    {row.getVisibleCells().map(cell => (
                      <td key={cell.id}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {enablePagination && (
        <div className="d-flex justify-content-between py-2 mt-2">
          <div className="text-filed">
            <p className="color-black font-14">{`${totalRecords} ${recordCountText}`}</p>
          </div>
          <div className="pagination">
            <div className="form-group white-drop mb-0">
              <select
                style={{
                  display: 'flex',
                  width: '50px',
                  flexDirection: 'column',
                  gap: '4px',
                  height: '50px',
                  alignItems: 'center',
                  paddingTop: '13px'
                }}
                value={initialPageSize}
                onChange={handlePageSizeChange}
              >
                {[10, 25, 50].map(size => (
                  <option key={size} value={size}>{size}</option>
                ))}
              </select>
              <label className="text-nowrap font-14 py-3 ms-3 me-3">Per page</label>
            </div>
            <div className="pagination-wrapper">
              <button
                className="pagination-button"
                onClick={() => navigatePage('prev')}
                disabled={isFirstPage}
              >
                {"<"}
              </button>
              <div className="pagination-current-page">
                <span>{String(pageNumber).padStart(2, '0')}</span> </div> 
                <span>of </span>
                <span className="ms-2">{String(totalPages).padStart(2, '0')}</span>
              <button
                className="pagination-button ms-2"
                onClick={() => navigatePage('next')}
                disabled={isLastPage}
              >
                {">"}
              </button>
            </div>


            {/* <nav aria-label="Page navigation">
              <ul className="pagination gr-paggi">
                <li className="page-item"><button className="page-link" disabled={isFirstPage}
                  style={isFirstPage ? disabledButtonStyle : {}} onClick={() => navigatePage('first')}>{"<<"}</button></li>
                <li className="page-item"><button className="page-link" disabled={isFirstPage}
                  style={isFirstPage ? disabledButtonStyle : {}} onClick={() => navigatePage('prev')}>{"<"}</button></li>
                <li className="page-item"><button className="page-link" disabled={isLastPage}
                  style={isLastPage ? disabledButtonStyle : {}} onClick={() => navigatePage('next')}>{">"}</button></li>
                <li className="page-item"><button className="page-link" disabled={isLastPage}
                  style={isLastPage ? disabledButtonStyle : {}} onClick={() => navigatePage('last')}>{">>"}</button></li>
              </ul>
            </nav> */}
          </div>
        </div>
      )}
    </>
  );
};

export default MainTable;
















// import React, { useMemo } from "react";
// import "./TableStyles.css";
// import {
//   useReactTable,
//   flexRender,
//   getCoreRowModel,
//   getPaginationRowModel,
//   ColumnDefBase
// } from "@tanstack/react-table";


// const MainTable = ({
//   columns, data, initialPageSize , pageNumber, onPageIndexChange, onPageSizeChange = () => { }, enablePagination = true,
//   totalRecords, // New prop for total records count
//   className = "", // New prop for custom className
//   recordCountText = "records found" }) => {
//   // Ensure pageNumber is a valid number, defaulting to 1 if not
//   // const pageIndex = pageNumber - 1;
//   const pageIndex = useMemo(() => pageNumber - 1, [pageNumber]);

//   console.log('My PageNumber Value ::', pageIndex)
//   const finalData = useMemo(() => data, [data]);
//   const finalColumnDef = useMemo(() => columns, [columns]);
//   const tableModelHooks = [getCoreRowModel()];
//   if (enablePagination) {
//     tableModelHooks.push(getPaginationRowModel());
//   }

//   const tableInstance = useReactTable({
//     columns: finalColumnDef,
//     data: finalData,
//     getCoreRowModel: getCoreRowModel(),
//     getPaginationRowModel: getPaginationRowModel(),
//     // ColumnDefBase: { navigateCallback }, // Pass the navigate callback
//     options: {
//       state: {
//         pagination: {
//           pageIndex,
//           pageSize: initialPageSize,
//         },
//       },
//     },
//   });
//   const totalPages = Math.ceil(totalRecords / initialPageSize);

//   const handlePageSizeChange = (e) => {
//     const newSize = parseInt(e.target.value);
//     onPageSizeChange(newSize);
//     onPageIndexChange(1);
//   };

//     // Adjust navigation methods considering totalPages
//     const handleFirstPage = () => onPageIndexChange(1);
//     const handlePreviousPage = () => onPageIndexChange(Math.max(0, pageNumber - 1));
//     const handleNextPage = () => onPageIndexChange(Math.min(pageNumber + 1, totalPages - 1));
//     const handleLastPage = () => onPageIndexChange(totalPages - 1);
//   // console.log("test", tableInstance.getHeaderGroups());
//   // const handlePageSizeChange = (e) => {
//   //   const newSize = parseInt(e.target.value, 12);
//   //   tableInstance.setPageSize(newSize);
//   //   onPageSizeChange(newSize);
//   // };
//   // // Adjusted navigation methods
//   // const handleFirstPage = () => onPageIndexChange(1);
//   // const handlePreviousPage = () => onPageIndexChange(Math.max(1, pageIndex - 1));
//   // const handleNextPage = () => onPageIndexChange(Math.min(pageIndex + 1, tableInstance.getPageCount()));
//   // const handleLastPage = () => onPageIndexChange(tableInstance.getPageCount());

//   return (
//     <>

//       <div className={`card ${className}`}>
//         <div className="card-body">
//           <div className="table-responsive">
//             <table className="cspadi table">
//               <thead className="table-header">
//                 {tableInstance.getHeaderGroups().map((headerEl) => {
//                   return (
//                     <tr key={headerEl.id}>
//                       {headerEl.headers.map((columnEl) => {
//                         return (
//                           <th key={columnEl.id} colSpan={columnEl.colSpan}>
//                             {columnEl.isPlaceholder
//                               ? null
//                               : flexRender(
//                                 columnEl.column.columnDef.header,
//                                 columnEl.getContext()
//                               )}
//                           </th>
//                         );
//                       })}
//                     </tr>
//                   );
//                 })}
//               </thead>
//               <tbody>
//                 {tableInstance.getRowModel().rows.map((rowEl) => {
//                   return (
//                     <tr key={rowEl.id}>
//                       {rowEl.getVisibleCells().map((cellEl) => {
//                         return (
//                           <td key={cellEl.id}>
//                             {flexRender(
//                               cellEl.column.columnDef.cell,
//                               cellEl.getContext()
//                             )}
//                           </td>
//                         );
//                       })}
//                     </tr>
//                   );
//                 })}
//               </tbody>
//             </table>
//           </div>

//         </div>
//       </div>
//       {enablePagination && (
//         <div className="d-flex justify-content-between py-2 mt-2">
//           <div className="text-filed">
//             <p className="color-black font-14">{`${finalData.length} ${recordCountText}`}</p>
//           </div>
//           <div className="pagination">
//             <div className="form-group white-drop mb-0">
//               {/* <select className="pageSizeSelector" value={tableInstance.options.state.pagination.pageSize} onChange={handlePageSizeChange}> */}

//               <select
//                 style={{
//                   display: 'flex',
//                   width: '50px',
//                   flexDirection: 'column',
//                   // alignItems: 'flex-start',
//                   gap: '4px',
//                   height: '50px',
//                   alignItems: 'center',
//                   paddingTop: '13px'
//                 }}
//                 value={initialPageSize}
//                 onChange={handlePageSizeChange}
//               >
//                 {[10, 25, 50].map((size) => (
//                   <option key={size} value={size}>
//                     {size}
//                   </option>
//                 ))}
//               </select>
//               <lable className="text-nowrap font-14 py-3 ms-2">
//               <p className="color-black font-14">{`${totalRecords} ${recordCountText}`}</p>
//                 </lable>
//             </div>
//             <nav aria-label="P  age navigation">
//               <ul className="pagination gr-paggi">
//                 <li className="page-item">
//                   <button className="page-link" onClick={handleFirstPage} >{"<<"}</button>
//                 </li>
//                 <li className="page-item">
//                   <button className="page-link" onClick={handlePreviousPage} >{"<"}</button>
//                 </li>
//                 {/* ... other page items ... */}
//                 <li className="page-item">
//                   <button className="page-link" onClick={handleNextPage}>{">"}</button>
//                 </li>
//                 <li className="page-item">
//                   <button className="page-link" onClick={handleLastPage}>{">>"}</button>
//                 </li>
//               </ul>
//             </nav>

//           </div>

//         </div >)}
//         {/* <pre>{JSON.stringify(tableInstance.getState().pagination, null, 2)}</pre> */}
//     </>
//   );
// };

// export default MainTable;
